import MuiFade from "@mui/material/Fade";
const Fade = MuiFade;
export default Fade;
